import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Programs() {
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const [data, setData] = useState(null);
  const limit = 25;

  useEffect(() => {
    api.get(`/admin/programs-table?q=${encodeURIComponent(q)}&skip=${skip}&limit=${limit}`)
      .then(({ data }) => setData(data)).catch(() => {});
  }, [q, skip]);
  useEffect(() => { setSkip(0); }, [q]);

  return (
    <div className="px-4 md:px-8 py-8 max-w-6xl" data-testid="hq-programs-page">
      <div className="text-xs tracking-widest text-volt">ADMIN HQ · RECORDS</div>
      <h1 className="heading text-4xl mt-1">PROGRAMS</h1>
      <p className="text-neutral-400 mt-2 text-sm max-w-2xl">Every organization in the knowledge graph, with staff coverage and open jobs.</p>

      <div className="mt-6 flex items-end gap-3 flex-wrap">
        <input data-testid="programs-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search program name…"
          className="bg-black border border-neutral-800 px-3 py-2 text-sm w-72 focus:border-volt outline-none" />
        {data && <span className="text-xs text-neutral-500 ml-auto" data-testid="programs-total">{data.total.toLocaleString()} programs · showing {skip + 1}–{Math.min(skip + limit, data.total)}</span>}
      </div>

      {!data ? (
        <div className="mt-6 text-neutral-500 text-sm">Loading…</div>
      ) : (
        <>
          <div className="mt-4 overflow-x-auto border border-neutral-800">
            <table className="w-full text-sm" data-testid="programs-table">
              <thead>
                <tr className="text-left text-[10px] tracking-widest text-neutral-500 border-b border-neutral-800 bg-appcard">
                  <th className="py-2.5 px-3">PROGRAM</th>
                  <th className="py-2.5 px-3">DIV</th>
                  <th className="py-2.5 px-3">STAFF</th>
                  <th className="py-2.5 px-3">EMAILS</th>
                  <th className="py-2.5 px-3">CLAIMED</th>
                  <th className="py-2.5 px-3">OPEN JOBS</th>
                  <th className="py-2.5 px-3 text-right"></th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((p, i) => (
                  <tr key={i} className="border-b border-neutral-900 hover:bg-neutral-900/40" data-testid={`program-row-${i}`}>
                    <td className="py-2.5 px-3 text-white text-xs">{p.organization}</td>
                    <td className="py-2.5 px-3 text-neutral-400 text-xs">{p.division || "—"}</td>
                    <td className="py-2.5 px-3 text-neutral-300 text-xs">{p.staff}</td>
                    <td className={`py-2.5 px-3 text-xs ${p.emails ? "text-volt" : "text-neutral-600"}`}>{p.emails}</td>
                    <td className={`py-2.5 px-3 text-xs ${p.claimed ? "text-emerald-400" : "text-neutral-600"}`}>{p.claimed}</td>
                    <td className={`py-2.5 px-3 text-xs ${p.open_jobs ? "text-blaze" : "text-neutral-600"}`}>{p.open_jobs}</td>
                    <td className="py-2.5 px-3 text-right">
                      <a href={`/hq/coaches?q=${encodeURIComponent(p.organization)}`} className="text-[10px] tracking-widest text-volt hover:underline">STAFF →</a>
                    </td>
                  </tr>
                ))}
                {data.items.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-neutral-500">No programs match.</td></tr>}
              </tbody>
            </table>
          </div>
          <div className="mt-3 flex items-center gap-3 text-[11px] text-neutral-500">
            <button data-testid="programs-prev" disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - limit))} className="border border-neutral-700 px-2.5 py-1.5 disabled:opacity-40"><ChevronLeft size={12} /></button>
            <span>{skip + 1}–{Math.min(skip + limit, data.total)} of {data.total}</span>
            <button data-testid="programs-next" disabled={skip + limit >= data.total} onClick={() => setSkip(skip + limit)} className="border border-neutral-700 px-2.5 py-1.5 disabled:opacity-40"><ChevronRight size={12} /></button>
          </div>
        </>
      )}
    </div>
  );
}
